<template>
  <v-container>
    <v-row :dense="true">
      <v-col :cols="cols[0]">
        <v-btn-group density="compact" direction="vertical">
          <v-btn
            v-model="show_open"
            :active="show_open"
            :readonly="show_open && !show_closed"
            @click="toggleOpen"
            >open</v-btn
          >
          <v-btn
            v-model="show_closed"
            :active="show_closed"
            :readonly="show_closed && !show_open"
            @click="toggleClosed"
            >closed</v-btn
          >
        </v-btn-group>
      </v-col>
      <v-col :cols="cols[1]">
        <v-select
          v-model="sortOption"
          density="compact"
          :details="true"
          :items="sortOptions"
          label="sort"
          menu-icon=""
          @update:model-value="change"
        />
      </v-col>
      <v-col v-if="labels" :cols="cols[2]">
        <v-select
          v-model="selectedLabels"
          chips
          clearable
          density="compact"
          :items="labels"
          label="filter by label"
          menu-icon=""
          multiple
          @update:model-value="change"
        />
      </v-col>
      <v-col :cols="cols[2]">
        <v-text-field
          v-model="query"
          density="compact"
          label="search"
          @update:model-value="change"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import type { Issue, IssueListIssuesParams } from "../gen/forgejo-vue";
import { IssueListIssuesSort } from "../gen/forgejo-vue";
import { computed, type Ref, ref, shallowRef } from "vue";
import { useDisplay } from "vuetify";

const props = defineProps<{
  issues: Issue[];
}>();
const emit =
  defineEmits<(e: "change", params: IssueListIssuesParams) => void>();

const { lgAndUp } = useDisplay();
const cols = computed((): [number, number, number] => {
  return lgAndUp.value ? [1, 5, 6] : [2, 10, 12];
});

const show_open = ref(true);
const show_closed = ref(false);
const selectedLabels = shallowRef([]);
const query = ref("");

const labels = computed(() => {
  const newLabels = new Set<string>();
  for (const label of selectedLabels.value) {
    newLabels.add(label);
  }
  for (const item of props.issues) {
    if (item.labels) {
      for (const label of item.labels) {
        if (label.name) {
          newLabels.add(label.name);
        }
      }
    }
  }
  return Array.from(newLabels);
});

const sortOption: Ref<IssueListIssuesSort> = ref("recentupdate");

const sortOptions = ref(
  (() => {
    const sorts: string[] = [];
    for (const v in IssueListIssuesSort) {
      sorts.push(v);
    }
    return sorts;
  })(),
);

function toggleOpen() {
  if (!show_open.value || show_closed.value) {
    show_open.value = !show_open.value;
    change();
  }
}
function toggleClosed() {
  if (!show_closed.value || show_open.value) {
    show_closed.value = !show_closed.value;
    change();
  }
}

function change() {
  const state = show_open.value
    ? show_closed.value
      ? "all"
      : "open"
    : "closed";
  emit("change", {
    ...(state !== "open" && { state }),
    ...(selectedLabels.value.length > 0 && {
      labels: selectedLabels.value.join(","),
    }),
    ...(sortOption.value !== "relevance" && { sort: sortOption.value }),
    ...(query.value && { q: query.value }),
  });
}
</script>
